export default class HighlightContentCard {
    visible = false;

    init() {
        window.addEventListener('scroll', this.checkVisibility.bind(this));
    }

    checkVisibility() {
        if(this.isElementInRange(this.$el)) {
            this.visible = true;
        } else {
            this.visible = false;
        }
    }

    isElementInRange(element) {
        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Calculate the middle of the element
        const elementMiddle = rect.top + rect.height / 2;

        // Calculate the range
        const lowerBound = viewportHeight * 0.25;
        const upperBound = viewportHeight * 0.80;

        // Check if the middle of the element is within the range
        return elementMiddle >= lowerBound && elementMiddle <= upperBound;
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('highlightContentCard', () => new HighlightContentCard());
});